import { Component, HostBinding, Input } from '@angular/core';
import { SiteService } from '@app/_services/site.service';
import { theme } from '../../../../data/theme';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgIf, NgFor, NgClass } from '@angular/common';

export interface SocialLinksItem {
    type: string;
    url: string;
    icon: string;
}

export type SocialLinksShape = 'circle' | 'rounded';

@Component({
    selector: 'app-social-links',
    templateUrl: './social-links.component.html',
    styleUrls: ['./social-links.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor, NgClass, ExtendedModule]
})
export class SocialLinksComponent {
    theme = theme;

    items: SocialLinksItem[] = [
        {type: 'facebook', url: 'https://www.facebook.com/qetaatcom/', icon: 'fab fa-facebook-f'},
        {type: 'twitter', url: 'https://twitter.com/qetaat', icon: 'fab fa-twitter'},
        {type: 'instagram', url: 'https://www.instagram.com/qetaatcom.con/', icon: 'fab fa-instagram'},
        {type: 'linkedin', url: 'https://www.linkedin.com/in/qetaatcom/', icon: 'fab fa-linkedin-in'},
        // {type: 'youtube', url: this.theme.author.profile_url, icon: 'fab fa-youtube'},
        // {type: 'rss', url: this.theme.author.profile_url, icon: 'fas fa-rss'},
    ];

    siteItems: SocialLinksItem[] = [
        ...(this.siteService?.siteSetting?.socialMedia?.facebook.active) ? [{ type: 'facebook', url: this.siteService.siteSetting.socialMedia.facebook.link, icon: 'fab fa-facebook-f' }] : [],
        ...(this.siteService?.siteSetting?.socialMedia?.twitter.active) ? [{ type: 'twitter', url: this.siteService.siteSetting.socialMedia.twitter.link, icon: 'fab fa-twitter' }] : [],
        ...(this.siteService?.siteSetting?.socialMedia?.instagram.active) ? [{ type: 'instagram', url: this.siteService.siteSetting.socialMedia.instagram.link, icon: 'fab fa-instagram' }] : [],
        ...(this.siteService?.siteSetting?.socialMedia?.linkedin.active) ? [{ type: 'linkedin', url: this.siteService.siteSetting.socialMedia.linkedin.link, icon: 'fab fa-linkedin-in' }] : [],
        // {type: 'youtube', url: this.theme.author.profile_url, icon: 'fab fa-youtube'},
        // {type: 'rss', url: this.theme.author.profile_url, icon: 'fas fa-rss'},
    ];

    @Input() shape: SocialLinksShape;

    @HostBinding('class.social-links') classSocialLinks = true;

    @HostBinding('class.social-links--shape--circle') get classSocialLinksShapeCircle(): boolean { return this.shape === 'circle'; }

    @HostBinding('class.social-links--shape--rounded') get classSocialLinksShapeRounded(): boolean { return this.shape === 'rounded'; }

    constructor(public siteService: SiteService) { }
}
